/**
 * Method to detect price slider change
 * @param nextSliderValueArray Array, next price slider value object.
 * @param currentSliderValueArray Array, current price slider value object
 * @returns true if price slider has been changed
 *
 */
const sliderValueChanged = (nextSliderValueArray = [], currentSliderValueArray = []) => {
  const [currentValue] = currentSliderValueArray;
  const [nextValue] = nextSliderValueArray;

  return currentValue !== nextValue;
};

/**
 * Method to detect listingCategories and excludeCategories change
 * @param nextSortValueArray Array or String, next listingCategories or excludeCategories.
 * @param currentSortValueArray Array or String, current listingCategories or excludeCategories.
 * @returns true if listingCategories or excludeCategories has been changed
 *
 */
const isCategoryOrDeliveryTypeChanged = (nextSortValueArray, currentSortValueArray) => {
  if (typeof nextSortValueArray !== typeof currentSortValueArray) {
    return true;
  }
  if (typeof nextSortValueArray === 'number' && typeof currentSortValueArray === 'number') {
    return !(nextSortValueArray === currentSortValueArray);
  }
  if (Array.isArray(nextSortValueArray) && Array.isArray(currentSortValueArray)) {
    if (nextSortValueArray.length !== currentSortValueArray.length) {
      return true;
    }

    for (let i = 0; i < currentSortValueArray.length; i++) {
      if (nextSortValueArray[i] !== currentSortValueArray[i]) {
        return true;
      }
    }
  }

  return false;
};

export {sliderValueChanged, isCategoryOrDeliveryTypeChanged};
